import ConsoleApi from "apps/console/enums/consoleApi";
import { QueryClient, UseQueryResult } from "react-query";
import { useGetApiData } from "shared/datalayer";
import { ApiRegistrationParticipantForListForAdminResponse, UpdateFilterFunctionConfig } from "./types";
import { ApiRegistrationParticipantFilterCountResponse } from "shared/types/ApiRegistrationParticipantFilterCountResponse";

function getApprovalsListKey(registrationId: string) {
  return [ConsoleApi.APPROVAL_LIST, registrationId];
}

export function useGetApprovalsList({
  registrationId,
  successHandler
}: {
  registrationId: string;
  successHandler: ({ data }: UpdateFilterFunctionConfig) => void;
}): UseQueryResult<ApiRegistrationParticipantForListForAdminResponse[]> {
  return useGetApiData(
    ConsoleApi.APPROVAL_LIST,
    { params: { registrationId } },
    {
      enabled: Boolean(registrationId),
      onSuccess: data => successHandler({ data })
    }
  );
}

export function updateApprovalsList({
  queryClient,
  data,
  registrationId
}: {
  queryClient: QueryClient;
  data: ApiRegistrationParticipantForListForAdminResponse;
  registrationId: string;
}) {
  queryClient.setQueryData<Array<ApiRegistrationParticipantForListForAdminResponse>>(
    getApprovalsListKey(registrationId),
    (list = []) => {
      const isExistingParticipant = list.find(item => item.id === data.id);

      if (isExistingParticipant) {
        return list.map(regParticipant =>
          regParticipant.id === data.id ? { ...regParticipant, ...data } : regParticipant
        );
      }

      return [...list, data];
    }
  );
}

export function getPaginatedListCountByStatusKey(registrationId: string) {
  return [ConsoleApi.REGISTRATION_PARTICIPANT_LIST_PAGINATED_COUNT, registrationId];
}

export function useGetPaginatedListCountByStatus(registrationId: string) {
  return useGetApiData<ApiRegistrationParticipantFilterCountResponse>(
    ConsoleApi.REGISTRATION_PARTICIPANT_LIST_PAGINATED_COUNT,
    { params: { registrationId } },
    {
      enabled: Boolean(registrationId),
      queryKey: getPaginatedListCountByStatusKey(registrationId)
    }
  );
}
